<template>
  <div>
      <el-dialog title="SSH 用户名" :visible.sync="visible" width="400px" :close-on-click-modal="false">
        <div class="term-username">
          <div class="term-username-info">连接会话: {{sessAndPath && sessAndPath.sess ? sessAndPath.sess.Name : ""}}</div>
          <div class="term-username-info">远程主机: {{sessAndPath && sessAndPath.sess ? sessAndPath.sess.Host : ""}}:{{sessAndPath && sessAndPath.sess ? sessAndPath.sess.Port : ""}}</div>
          <br>
          <div class="term-username-input">请输入登陆的用户名:</div>
          <el-input :id="`t-i-u-${tabID}`"
              clearable autocomplete @keyup.native.enter="okHandler" v-model="inputUser" size="mini"
              class="term-username-input" />
          <el-checkbox class="term-username-input" v-model="rememberUser" @keyup.native.enter="okHandler">记住用户名</el-checkbox>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false" size="mini">取 消</el-button>
          <el-button v-show="!sessPosting" @click="okHandler" size="mini" type="primary">确 定</el-button>
          <el-button v-show="sessPosting" size="mini" type="primary" class="el-loading" />
        </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "sshUserInput",
  props: ["tabID", "sessAndPath", "session"],
  data() {
    return {
      visible: false,
      inputUser: "",
      rememberUser: false,
      inputUserCtrlMsg: {},
      sentUser: false,
      sessPosting: false,
    }
  },
  watch: {
    visible: function(v) {
      if (v === true) {
        this.sentUser = false
        this.focusInputUser()
      } else {
        this.focusCurTerm()
        if (!this.sentUser) this.session.Close()
      }
    }
  },
  methods: {
    show(cmdMsg) {
      this.visible = true
      this.inputUserCtrlMsg = cmdMsg
    },
    hide() {
      this.visible = false
    },
    okHandler() {
      if (this.sessPosting) {
        return
      }
      // 先更新 session, 更新成功再发送用户, 更新失败则不发送登录用户
      this.rememberUser ? this.postSessionAndSendUser() : this.sendUser()
    },
    focusInputUser() {
      this.utils.domFocusById(`t-i-u-${this.tabID}`)
    },
    focusCurTerm() {
      this.env.pub('focusTerm-' + this.tabID)
    },
    sendUser() {
      console.log("sendUser")
      this.session.SendCtrlRet(this.inputUser, undefined, this.inputUserCtrlMsg)
      this.sentUser = true
      this.hide()
    },
    // 推送 session 到服务器, 推送成功之后再发送 username 以让当前会话登录
    // 如果推送 session 失败则不推送 username
    postSessionAndSendUser() {
      let self = this
      self.sessPosting = true
      self.sessAndPath.sess.User = self.inputUser
      let blob = new Blob([JSON.stringify(self.sessAndPath.sess)])
      self.api.hifs.postFile(`${self.env.sess.basePath}/${self.sessAndPath.path}`, blob, (error, data, response) => {
        self.sessPosting = false
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          console.log("postSession success. data", data)
          self.sendUser()
        }
      })
    },
  },
}
</script>

<style scoped>
.term-username {
    text-align: left;
    display: flex;
    flex-direction: column;
}
.term-username-info {
    padding: 0.4em 0.5em;
}
.term-username-input {
    padding: 0.2em 0.5em;
}
</style>
